module.exports = __webpack_public_path__ + "img/works_beijing_xikemu_6.663239a2.jpg";